import { DATA_FORMATS } from '../constants.js';

export const detectDataFormat = (tasks) => {
  if (!Array.isArray(tasks) || tasks.length === 0) return DATA_FORMATS.GROUPED;
  
  const firstItem = tasks[0];
  
  if (firstItem.type && firstItem.data && firstItem.level !== undefined) {
    return DATA_FORMATS.WBS;
  }
  
  if (firstItem.type === 'row' && firstItem.data) {
    return DATA_FORMATS.FLAT;
  }
  
  if (firstItem.title !== undefined && firstItem.items !== undefined && firstItem.type === 'group') {
    return DATA_FORMATS.NESTED_GROUP;
  }
  
  if (firstItem.title !== undefined && firstItem.items !== undefined) {
    return DATA_FORMATS.GROUPED;
  }
  
  return DATA_FORMATS.GROUPED;
};